<template>
  <div class="service-policy-page">
    <!-- Navbar Area -->
    <div class="navbar-area" :class="{ 'is-sticky': isSticky }">
      <div class="template-responsive-navbar">
          <div class="container">
              <div class="template-responsive-menubar">
                  <div class="logo">
                      <router-link to="/">
                        <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                      </router-link>
                  </div>
                  <div class="meanmenu-reveal" id="meanmenu-reveal" @click="toggleMobileMenu"><span></span></div>
              </div>
          </div>
          <!-- Mobile Menu -->
          <div class="mean-nav" :class="{ 'mean-show': isMobileMenuOpen }">
              <div class="mobile-menu-container">
                  <ul class="navbar-nav">
                    <li class="nav-item"><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'services')">{{ t.services }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'services' }">
                        <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                        <li class="nav-item"><router-link to="/static" class="nav-link">{{ t.serviceStatic }}</router-link></li>
                      </ul>
                    </li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'blog')">{{ t.blog }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'blog' }">
                        <li class="nav-item"><router-link to="/faq" class="nav-link">{{ t.faq }}</router-link></li>
                      </ul>
                    </li>
                    
                    <!-- Language Switcher -->
                    <li class="nav-item">
                      <a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'language')">
                        {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }} <i class="bx bx-plus dropdown-icon"></i>
                      </a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'language' }">
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')" style="padding: 10px 0 10px 20px;">English</button></li>
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')" style="padding: 10px 0 10px 20px;">中文</button></li>
                      </ul>
                    </li>
                  </ul>
                  
                  <div class="others-option d-flex flex-column mt-4">
                    <div class="item mb-3">
                      <a href="/login" class="default-btn">{{ t.signIn }}</a>
                    </div>
                    
                    <div class="item">
                      <a href="/register" class="default-btn">{{ t.signUp }}</a>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="template-navbar">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <router-link class="navbar-brand" to="/">
              <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
            </router-link>

            <button class="navbar-toggler" type="button" @click="isNavCollapsed = !isNavCollapsed" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse mean-menu" :class="{ 'show': !isNavCollapsed }">
              <ul class="navbar-nav">
                <li class="nav-item"><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.services }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                    
                    <li class="nav-item"><router-link to="/static" class="nav-link">{{ t.serviceStatic }}</router-link></li>
                  </ul>
                </li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.blog }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/faq" class="nav-link">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                
                <!-- Language Switcher -->
                <li class="nav-item">
                  <a href="#" class="dropdown-toggle nav-link">
                    {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')">English</button></li>
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')">简体中文</button></li>
                  </ul>
                </li>
              </ul>

              <div class="others-option d-flex align-items-center">
                <div class="item">
                  <a href="/login" class="default-btn">{{ t.signIn }}</a>
                </div>

                <div class="item">
                  <a href="/register" class="default-btn">{{ t.signUp }}</a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- End Navbar Area -->

    <!-- Banner Section -->
    <section class="faq-banner-section ptb-100">
      <div class="container">
        <div class="banner-content text-center">
          <h1>{{ t.servicePolicyTitle }}</h1>
          <p>{{ t.servicePolicySubtitle }}</p>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- Service Policy Content Section -->
    <section class="policy-content-section ptb-100 bg-light">
      <div class="container">
        <div class="policy-content">
          <div class="policy-header">
            <h2>{{ languageState.currentLanguage === 'en' ? serviceData.title1 : serviceDataZh.title1 }}</h2>
            <div class="policy-meta">
              <span>{{ languageState.currentLanguage === 'en' ? serviceData.title2 : serviceDataZh.title2 }}</span>
              <span>{{ languageState.currentLanguage === 'en' ? serviceData.title3 : serviceDataZh.title3 }}</span>
            </div>
          </div>
          
          <div class="policy-body">
            <div class="policy-section">
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title4 : serviceDataZh.title4 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title5 : serviceDataZh.title5 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title6 : serviceDataZh.title6 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title7 : serviceDataZh.title7 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title8 : serviceDataZh.title8 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title9 : serviceDataZh.title9 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title10 : serviceDataZh.title10 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title11 : serviceDataZh.title11 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title12 : serviceDataZh.title12 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title13 : serviceDataZh.title13 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title14 : serviceDataZh.title14 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title15 : serviceDataZh.title15 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title16 : serviceDataZh.title16 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title17 : serviceDataZh.title17 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title18 : serviceDataZh.title18 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title19 : serviceDataZh.title19 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title20 : serviceDataZh.title20 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title21 : serviceDataZh.title21 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title22 : serviceDataZh.title22 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title23 : serviceDataZh.title23 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title24 : serviceDataZh.title24 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title25 : serviceDataZh.title25 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title26 : serviceDataZh.title26 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title27 : serviceDataZh.title27 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title28 : serviceDataZh.title28 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title29 : serviceDataZh.title29 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title30 : serviceDataZh.title30 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title31 : serviceDataZh.title31 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title32 : serviceDataZh.title32 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title33 : serviceDataZh.title33 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title34 : serviceDataZh.title34 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title35 : serviceDataZh.title35 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title36 : serviceDataZh.title36 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title37 : serviceDataZh.title37 }}</h3>
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title38 : serviceDataZh.title38 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title39 : serviceDataZh.title39 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title40 : serviceDataZh.title40 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title41 : serviceDataZh.title41 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title42 : serviceDataZh.title42 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title43 : serviceDataZh.title43 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title44 : serviceDataZh.title44 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title45 : serviceDataZh.title45 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title46 : serviceDataZh.title46 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title47 : serviceDataZh.title47 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title48 : serviceDataZh.title48 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title49 : serviceDataZh.title49 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title50 : serviceDataZh.title50 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title51 : serviceDataZh.title51 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title52 : serviceDataZh.title52 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title53 : serviceDataZh.title53 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title54 : serviceDataZh.title54 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title55 : serviceDataZh.title55 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title56 : serviceDataZh.title56 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title57 : serviceDataZh.title57 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title58 : serviceDataZh.title58 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title59 : serviceDataZh.title59 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title60 : serviceDataZh.title60 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title61 : serviceDataZh.title61 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title62 : serviceDataZh.title62 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title63 : serviceDataZh.title63 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title64 : serviceDataZh.title64 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title65 : serviceDataZh.title65 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title66 : serviceDataZh.title66 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title67 : serviceDataZh.title67 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title68 : serviceDataZh.title68 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title69 : serviceDataZh.title69 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title70 : serviceDataZh.title70 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title71 : serviceDataZh.title71 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title72 : serviceDataZh.title72 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title73 : serviceDataZh.title73 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title74 : serviceDataZh.title74 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title75 : serviceDataZh.title75 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title76 : serviceDataZh.title76 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title77 : serviceDataZh.title77 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title78 : serviceDataZh.title78 }}</p>
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title79 : serviceDataZh.title79 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title80 : serviceDataZh.title80 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title81 : serviceDataZh.title81 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title82 : serviceDataZh.title82 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title83 : serviceDataZh.title83 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title84 : serviceDataZh.title84 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title85 : serviceDataZh.title85 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title86 : serviceDataZh.title86 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title87 : serviceDataZh.title87 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title88 : serviceDataZh.title88 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title89 : serviceDataZh.title89 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title90 : serviceDataZh.title90 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title83 : serviceDataZh.title83 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title84 : serviceDataZh.title84 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title85 : serviceDataZh.title85 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title86 : serviceDataZh.title86 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title87 : serviceDataZh.title87 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title88 : serviceDataZh.title88 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title89 : serviceDataZh.title89 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title90 : serviceDataZh.title90 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title91 : serviceDataZh.title91 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title92 : serviceDataZh.title92 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title93 : serviceDataZh.title93 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title94 : serviceDataZh.title94 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title95 : serviceDataZh.title95 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title96 : serviceDataZh.title96 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title97 : serviceDataZh.title97 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title98 : serviceDataZh.title98 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title99 : serviceDataZh.title99 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title100 : serviceDataZh.title100 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title101 : serviceDataZh.title101 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title102 : serviceDataZh.title102 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title103 : serviceDataZh.title103 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title104 : serviceDataZh.title104 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title105 : serviceDataZh.title105 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title106 : serviceDataZh.title106 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title107 : serviceDataZh.title107 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title108 : serviceDataZh.title108 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title109 : serviceDataZh.title109 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title110 : serviceDataZh.title110 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title111 : serviceDataZh.title111 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title112 : serviceDataZh.title112 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title113 : serviceDataZh.title113 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title114 : serviceDataZh.title114 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title115 : serviceDataZh.title115 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title116 : serviceDataZh.title116 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title117 : serviceDataZh.title117 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title118 : serviceDataZh.title118 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title119 : serviceDataZh.title119 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title120 : serviceDataZh.title120 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title121 : serviceDataZh.title121 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title122 : serviceDataZh.title122 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title123 : serviceDataZh.title123 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title124 : serviceDataZh.title124 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title125 : serviceDataZh.title125 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title126 : serviceDataZh.title126 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title127 : serviceDataZh.title127 }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Service Policy Content Section -->

    <!-- Footer Section -->
    <footer class="footer-section pt-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.contactInfo }}</h3>
                        <ul class="footer-contact-info">
                            <!-- <li>Fish St Hill, Bridge, London EC3R 8AH, UK</li> -->
                            <li><a href="javascript:void(0);">super@proxylink.net</a></li>
                            <!-- <li><a href="tel:++254 25413 521">+254 25413 521</a></li>
                            <li><a href="tel:+254 25413 521">+254 25413 521</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget pl-4">
                        <h3>{{ t.usefulLinks }}</h3>
                        <ul class="links-list">
                            <!-- <li><a href="#">About Us</a></li> -->
                            <!-- <li><a href="#">Features</a></li> -->
                            <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                            <!-- <li><a href="#">Blog</a></li> -->
                            <!-- <li><a href="#">Contact</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.support }}</h3>
                        <ul class="links-list">
                            <li><router-link to="/privacy">{{ t.privacyPolicy }}</router-link></li>
                            <li><router-link to="/service-policy">{{ t.servicePolicy }}</router-link></li>
                            <!-- <li><a href="#">24/7 Support</a></li> -->
                            <!-- <li><a href="#">Contact Us</a></li> -->
                            <!-- <li><a href="#">About Us</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <a href="/" class="logo d-inline-block">
                            <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                        </a>
                        <p>{{ t.welcomeText }}</p>
                        <ul class="social-links">
                            <li><a href="javascript:void(0);"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="container">
                <p>{{ t.copyright }}</p>
            </div>
        </div>
    </footer>
    <!-- End Footer Section -->

    <div class="go-top" :class="{ 'active': showGoTop }" @click="scrollToTop"><i class='bx bx-up-arrow-alt'></i></div>
  </div>
</template>

<script>
export default {
  name: 'ServicePolicy',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      showGoTop: false,
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: null,
      serviceData: {
        title1: 'proxylink user service agreement',
        title2: 'The latest update time of the agreement: July 15, 2023',
        title3: 'Agreement effective date: July 15, 2023',
        title4: "The proxylink user service agreement is between the user ('you') and Jiangsu Aidi Information Technology Co., Ltd. (hereinafter referred to as 'Aidi' or 'we') on proxylink's official website (www.proxylink.net, 'this website') ) services and other related matters, please read it carefully. If you indicate your acceptance of this agreement by checking, clicking to confirm, or otherwise indicating your acceptance of this agreement, or if you use the proxylink service in any way, you will be deemed to have fully read it. Understand and agree to be bound by this agreement, and this agreement will have legal effect between you and proxylink.",
        title5: 'Article 1 General Provisions',
        title6: '1.1 Before using this service, you have fully read, understood and accepted all the contents of these Terms of Service (especially the highlighted contents). Once you select "Agree" and complete account registration or use this service, it means that you agree to abide by the terms of service. All agreements in these Terms of Service. Your use of proxylink services will be deemed as your acknowledgment of the entire contents of this Agreement and the "Proxylink Privacy Agreement".',
        title7: '1.2 You agree: proxylink reserves the right to update this agreement and the corresponding service rules at any time. If proxylink updates this appendix, proxylink will notify you by publishing an announcement on its official website. If you do not agree to the changes, you have the right to terminate your use of this service before the effective date of the new agreement or service rules. If you continue to use this service after the effective date of the new agreement or service rules, you will be deemed to have accepted the new agreement or service rules and waived your right to terminate the service in accordance with this article.',
        title8: "1.3 When you complete account registration or actually use the service in other ways permitted by proxylink, you should be a legal subject with full civil rights and full civil capacity. If you do not have the aforementioned civil capacity appropriate to your behavior, you should obtain the informed consent of your legal guardian. If you are under age, please read and determine whether you agree to this agreement with the company of your legal guardian. The minor's exercise and performance of the rights and obligations under this Agreement shall be deemed to have been recognized by the legal guardian.",
        title9: 'Article 2 Scope of Agreement',
        title10: "2.1 This agreement is an agreement between the user and proxylink regarding the use of proxylink’s services. 'proxylink' refers to the operating affiliated units that may exist for proxylink and/or its related services. 'User' refers to the user/enterprise of proxylink's services (including but not limited to registered users, free users, third-party channel login users and users affiliated with partners and agents), and is more commonly referred to as 'users' in this agreement. you'.",
        title11: '2.2 The services of proxylink refer to the services provided by proxylink to you. The specific services are subject to those actually provided by proxylink (hereinafter referred to as the "service").',
        title12: "2.3 The content of this agreement also includes the 'proxylink Privacy Agreement', and when you use a specific proxylink service, that service may have a separate agreement, relevant business rules, etc. (hereinafter collectively referred to as the 'separate agreement'). Once the above content is officially released, it will become an integral part of this Agreement and you shall also abide by it. Your acceptance of any of the foregoing separate agreements shall be deemed your acceptance of this Agreement in its entirety. Your acceptance of this agreement shall be deemed as your acceptance of the 'proxylink Privacy Agreement'.",
        title13: '2.4 Proxylink is only responsible for the scope of liability specified in these Terms of Service.',
        title14: '2.5 Proxylink shall not be liable for any indirect, punitive, special, derivative losses (including business losses, income losses, profit losses, usage data, goodwill, etc.) caused by breach of contract, infringement, etc. related to or arising from these Terms of Service. or other economic loss), regardless of how it arises, shall not be liable for any loss, even if it has been informed in advance of the possibility of such losses.',
        title15: 'Article 3 Account and Password Security',
        title16: '3.1 In order to use the proxylink service, you need to register a proxylink account (hereinafter referred to as the "account"). After you fill in the information as prompted on the registration page, read and agree to these Terms of Service, and complete the registration, or when you actually use the services of this website in other ways permitted by proxylink, you will be bound by these Terms of Service.',
        title17: '3.2 You should have the necessary and appropriate rights and capacity in accordance with the law, and have granted the operator sufficient rights to complete the registration process. You promise that the registration information you provide is true, accurate, complete, legal and valid. If your registration information changes, you should update the registration information in a timely manner. You shall bear full responsibility for all actions under the registered proxylink account and shall not infringe upon the legitimate rights and interests of any party, including but not limited to proxylink.',
        title18: '3.3 You understand and agree: To ensure the security of your account and transactions, proxylink has the right to require you to complete the real-name authentication of your proxylink account at any time; only after your account passes these authentications and verifications, can you be qualified to use proxylink related services.',
        title19: '3.4 You agree or accept: When necessary, we have the right to use your registration information, username, password and other information to log in to your registered account for evidence preservation, including but not limited to notarization, witnessing, etc.',
        title20: '3.5 The proxylink account is limited to your own use. You may not provide your account to others in any way without the consent of proxylink. You are responsible for the actions under your account. All operations under your account are deemed to be performed by you, and you shall bear all legal consequences.',
        title21: '3.6 Proxylink specifically reminds you to keep your account and password properly. When you are done using it, you should exit safely. Your account may be compromised or your password may be stolen due to poor storage, and you shall be solely responsible for this.',
        title22: 'Article 4 Privacy and Protection of Other Users’ Personal Information',
        title23: '4.1 Protecting users’ personal information is a basic principle of proxylink. proxylink will collect, use and store your personal information in accordance with the provisions of this agreement and the "proxylink privacy agreement". If this agreement does not clearly stipulate the protection of personal information, the contents of the "proxylink privacy agreement" shall prevail.',
        title24: '4.2 When you register an account or use this service, you need to fill in some necessary information (mobile phone number or identity information). According to national laws and regulations, you need to fill in your true identity information. If the information you fill in is incomplete, you may not be able to use this service or may be restricted during use.',
        title25: '4.3 Under normal circumstances, you can browse and modify the information you submitted according to relevant product rules, but for security and identity recognition reasons, you cannot modify the real-name authentication information.',
        title26: '4.4 Proxylink promises to keep your information confidential in accordance with the "Proxylink Privacy Agreement", not to disclose your information to third parties, and not to authorize third parties to use your information unless:',
        title27: '(1) It can be provided in accordance with this user agreement or other documents between you and proxylink;',
        title28: '(2) It should be provided in accordance with the provisions of laws and regulations;',
        title29: '(3) Administrative, judicial and other relevant national departments require proxylink to provide;',
        title30: '(4) You agree that proxylink will provide it to third parties;',
        title31: '(5) Submitted by proxylink to resolve reported incidents and file lawsuits;',
        title32: '(6) Proxylink must submit necessary and reasonable measures to prevent the occurrence of violations of laws and regulations and criminal acts;',
        title33: '(7) Proxylink provides products, services, and information to third parties in order to provide you with products, services, and information, including situations where proxylink provides products, services, and information to you through third-party technologies and services.',
        title34: '4.5 Proxylink only provides corresponding security measures based on existing technologies to prevent the information managed by Proxylink from being lost, but Proxylink does not promise to guarantee the absolute security of this information.',
        title35: '4.6 You agree: In order to better provide you with services, we may send you order information, promotions, etc. through emails, text messages, phone calls, etc. from time to time based on the information you provide, while ensuring that you are The right to be informed.',
        title36: 'Article 5 Services',
        title37: '5.1 How to use this service',
        title38: '5.1.1 The rights you obtain under the terms of this Agreement are only enjoyed by you and are not transferable.',
        title39: '5.1.2 You may not use any means (including but not limited to third-party software, plug-ins, systems, equipment, etc.) to interfere, destroy, modify or exert other influence on this service.',
        title40: '5.1.3 You should use this service through the methods provided or recognized by proxylink.',
        title41: '5.1.4 You should understand that when using this service, you need to prepare your own terminal equipment related to the relevant services (such as computers, mobile terminals, necessary network access equipment, etc.), and bear the required expenses (such as telephone charges, Internet access, etc.) fees, etc.).',
        title42: '5.1.5 You understand and agree that when you use this service, your terminal equipment, bandwidth and other resources will be consumed.',
        title43: '5.2 Service fees',
        title44: '5.2.1 Proxylink may modify and change the charging standards and methods of paid services based on actual needs, and proxylink may also start charging for some free services. Before the aforementioned modifications, changes or the start of charging, proxylink will notify or announce on the official website. If you do not agree to the above modifications, changes or paid content, you should stop using the service.',
        title45: '5.2.2 When proxylink reduces the charging standards of paid services or changes the paid services to free services, proxylink reserves the right not to provide refunds or fee adjustments to original paying users.',
        title46: '5.2.3 You know and agree that if one of the following circumstances occurs, proxylink will freeze part or all of the funds in your account:',
        title47: '(1) Provisions of national laws, policies, regulations, and effective legal documents;',
        title48: '(2) Relevant national competent authorities require freezing;',
        title49: '(3) Your use of proxylink services is suspected of violating national laws and regulations;',
        title50: '(4) You have been complained by others, and the other party has provided preliminary evidence, so that proxylink has reason to believe that the complaint exists;',
        title51: '(5) Other situations that proxylink believes may create risks based on its own reasonable judgment.',
        title52: '5.3 Services are provided as is',
        title53: 'You understand and agree:',
        title54: '(1) This service is provided according to the status quo that the existing technology and conditions can achieve. proxylink will do its best to ensure the continuity and security of the service, but proxylink cannot foresee and prevent legal, technical and other risks at any time. proxylink is exempt from liability for such risks to the extent permitted by law, including but not limited to force majeure, viruses, and Trojans. , hacker attacks, system instability, third-party service defects, government actions and other reasons that may cause service interruption, data loss and other losses and risks.',
        title55: '(2) Proxylink may make product or service adjustments based on business strategies or other development needs. The content of specific proxylink services available to users in different regions may be different. The actual content provided by proxylink shall prevail.',
        title56: '(3) The proxylink service price, quantity, availability and other information are subject to change at any time, and we will not make special notifications about this. We will do our best to ensure the accuracy of the information you browse on the proxylink official website. However, due to well-known Internet technical factors and other objective reasons, the information displayed on the proxylink official website may have certain lags or errors. In this case, you Know and understand that when using proxylink services, the actual situation shall prevail.',
        title57: "(4) Unless otherwise expressly stated in writing, all information, content, materials, products or services we provide to you are provided on an 'as is' and 'as available' basis. Unless otherwise expressly stated in writing, we make no representations or warranties of any kind, express or implied, as to the operation of this website and the information, content, materials, products or services contained on this website (in accordance with the laws of the People's Republic of China Unless otherwise specified).",
        title58: '(5) We do not guarantee that all the information, content, materials, products and services contained in this website or otherwise provided to you through this website, its servers or electronic letters and information sent from this website are free of viruses or other harmful Element. If the sales system of this site crashes or cannot be used normally due to force majeure or other reasons beyond the control of this site, resulting in the inability to complete online transactions or the loss of relevant information, records, etc., we will reasonably try our best to assist in handling the aftermath.',
        title59: '5.4 Service suspension, change and termination',
        title60: '5.4.1 You understand and agree that in order to provide you with more complete services, proxylink may conduct routine and planned maintenance, which may result in a short-term interruption or suspension of the services you are using. Based on adjustments to business strategies, proxylink may Changes to service content may also lead to service interruption or termination. Proxylink does not assume any responsibility to you for service interruption or suspension caused by such maintenance.',
        title61: '5.4.2 proxylink has the right to charge fees as stipulated in this agreement. If you fail to pay in full and on time, proxylink has the right to interrupt, suspend or terminate the service.',
        title62: '5.4.3 You are responsible for backing up the data stored in the Service yourself. If your service is terminated, proxylink has the right to permanently seal your data from the server, unless otherwise provided by laws and regulations. After the service is suspended or terminated, proxylink has no obligation to provide or return data to you.',
        title63: '5.4.4 When proxylink undergoes a merger, division, acquisition, or asset transfer, proxylink may transfer the relevant assets under this service to a third party; proxylink may also transfer some or all of the services and corresponding rights and obligations under this agreement to you after unilaterally notifying you. Transfers are operated or performed by third parties. The specific transferee shall be subject to the notice of proxylink.',
        title64: '5.4.5 If any of the following circumstances occurs, proxylink has the right to interrupt or terminate services to you without notice:',
        title65: '(1) According to laws and regulations, you should submit true information, but the personal information you provided is untrue or inconsistent with the information during registration and you fail to provide reasonable proof;',
        title66: '(2) You violate relevant laws and regulations or violate the terms of this Agreement;',
        title67: '(3) In accordance with laws and regulations, it is necessary to implement the instructions of courts, government agencies, judicial agencies and other competent authorities;',
        title68: '(4) To handle emergencies or other necessary situations related to the security or integrity of proxylink services.',
        title69: 'Article 6 Products or services provided by third parties',
        title70: 'If you obtain and use products or services provided by a third party through the proxylink website, the operator of the third-party products and services will establish a corresponding service relationship with you and assume responsibility for the products and services to you. Proxylink will only assume corresponding responsibilities to you within its own scope of responsibility in accordance with the service rules.',
        title71: 'Article 7 User’s violations of laws and regulations',
        title72: '7.1 You must abide by laws and regulations when using this service, and may not produce, copy, publish, disseminate information containing the following contents or engage in related activities, nor may you provide information for producing, copying, publishing, disseminating information containing the following contents or engaging in related activities. convenient:',
        title73: '(1) Opposing the basic principles established by the Constitution;',
        title74: '(2) Endangering national security, leaking state secrets, subverting state power, and undermining national unity;',
        title75: '(3) Damaging national honor and interests;',
        title76: '(4) Inciting ethnic hatred, ethnic discrimination, and undermining ethnic unity;',
        title77: '(5) Undermining national religious policies and promoting cults and feudal superstitions;',
        title78: '(6) Spread rumors, disrupt social order, and undermine social stability;',
        title79: '(7) Spread obscenity, pornography, gambling, violence, murder, terror or instigate crimes;',
        title80: "(8) Insulting or slandering others and infringing upon others' legitimate rights and interests;",
        title81: "(9) Violating the 'seven bottom lines' requirements of the bottom line of laws and regulations, the bottom line of the socialist system, the bottom line of national interests, the bottom line of citizens' legitimate rights and interests, the bottom line of social public order, the bottom line of morals and the bottom line of information authenticity;",
        title82: '(10) Prohibited by relevant laws and regulations or this agreement, relevant agreements, rules, etc.',
        title83: '7.2 If you violate relevant laws and regulations or the provisions of this Agreement when using this service, the relevant state agencies or institutions may file lawsuits, fines or take other sanctions against you, and require proxylink to provide assistance. You shall bear all the responsibility for any damage caused to you or others, and proxylink shall not bear any responsibility.',
        title84: '7.3 If you violate this agreement, proxylink has the right to make independent judgments and take corresponding measures. At the same time, proxylink has the right to take measures, including but not limited to suspending or terminating the provision of services to you, restricting, suspending, freezing or terminating your use of your account, and pursuing legal liability, depending on the nature of your behavior.',
        title85: '7.4 If you violate the provisions of this agreement and cause losses to any party, you shall bear the responsibility independently; if proxylink suffers losses as a result, you shall also compensate for the losses.',
        title86: '7.5 You must bear legal responsibility for your speech and behavior online. If you spread and disseminate reactionary, pornographic or other information that violates national laws on this website, the system records of this website may be used as evidence that you have violated the law.',
        title87: 'Article 8 Intellectual Property Rights',
        title88: '8.1 The intellectual property rights of the content provided by proxylink in this service (including but not limited to web pages, text, pictures, etc.) belong to proxylink. The intellectual property rights of the content generated when you use this service belong to you or the relevant rights holder, unless you There is another agreement with proxylink.',
        title89: '8.2 Unless otherwise stated, the copyrights, patent rights and other intellectual property rights on which proxylink provides this service belong to proxylink.',
        title90: '8.3 The copyrights, patent rights and other intellectual property rights of "proxylink", logo and other commercial marks used by proxylink in this service belong to proxylink.',
        title91: '8.4 The intellectual property rights of the above and any other content contained in this service are protected by laws and regulations. No one may use or create related derivative works in any form without the written permission of proxylink, you or the relevant rights holder.',
        title92: '8.5 It is your obligation to respect intellectual property rights. If there is any violation, you shall be liable for damages.',
        title93: 'Article 9 Force Majeure and Disclaimer',
        title94: '9.1 Force majeure refers to objective circumstances that cannot be foreseen by the parties to the agreement, or cannot be overcome or avoided by the parties, including but not limited to:',
        title95: '9.1.1 Natural disasters: such as floods, hail, tsunamis, typhoons, droughts, fires, etc.;',
        title96: '9.1.2 Government actions: For example, government authorities promulgate or adjust or change policies, laws, regulations, and adopt new behavioral measures, which lead to the inability to perform the agreement;',
        title97: '9.1.3 Social anomalies: such as riots, diseases, wars, strikes (but not including internal labor disputes between parties), etc.; other events that cannot be foreseen, cannot be overcome, cannot be avoided, and have a significant impact on one party or both ',
        title98: 'When the above situation occurs, proxylink will cooperate with the relevant departments in a timely manner and strive to handle it as soon as possible. However, proxylink will not be exempted from liability for any losses caused to you to the extent permitted by law.',
        title99: '9.2 If any party ("Affected Party") is unable to perform all or part of its obligations under this Agreement due to force majeure, it will not be deemed a breach of contract by the affected party, and the affected party will not be liable for any failure or delay in performance of its obligations under this Agreement due to force majeure. Any damage, loss, or increased expense suffered by the counterparty.',
        title100: '9.3 You understand and agree that due to the characteristics of Internet products and services, proxylink is not responsible for service abnormalities caused by the following circumstances to the extent permitted by law:',
        title101: '(1) Service interruption or delay caused by computer viruses, Trojan horses or other malicious programs, hacker attacks, technical adjustments or failures of the telecommunications department, etc.;',
        title102: '(2) The software, hardware equipment, systems, and communication lines that you manage and maintain fail, causing the proxylink service to be unable to be used normally and causing other derivative damage;',
        title103: '(3) You operate improperly, incorrectly, or you use this service in a manner not authorized by proxylink;',
        title104: '(4) Outdated program versions, aging equipment and/or compatibility issues;',
        title105: '(5) Other circumstances that are not caused by proxylink’s fault and that proxylink cannot control or reasonably foresee.',
        title106: 'Article 10 Comply with local legal supervision',
        title107: '10.1 When using this service, you should abide by relevant local laws and regulations, and respect local morals and customs. If your behavior violates local laws, regulations or moral customs, you shall be independently responsible for it.',
        title108: '10.2 You should avoid using this service to cause proxylink to violate laws and regulations or become involved in political and public events. Otherwise, proxylink has the right to suspend or terminate your service.',
        title109: 'Article 11 Contents you send and disseminate and complaint handling',
        title110: '11.1 The content you send or transmit through this service (including but not limited to web pages, text, pictures, audio, video, graphics, etc.) is your sole responsibility.',
        title111: '11.2 If the content you send or transmit is illegal or infringes upon the rights of others, proxylink has the right to make independent judgments and take measures including but not limited to suspending or terminating services to you, restricting, suspending, freezing or terminating your use of your account.',
        title112: '11.3 If you are complained by others or you complain against others, proxylink has the right to provide the relevant parties or relevant departments with the subject information, contact information, complaint-related content and other necessary information of the relevant parties in the dispute, so as to resolve the complaint disputes in a timely manner and protect all parties. Party’s legitimate rights and interests.',
        title113: '11.4 You guarantee that you are responsible for the authenticity, legality and validity of the information, materials, evidence, etc. you provide in the complaint handling procedure.',
        title114: 'Article 12 Service of Notice',
        title115: '12.1 You understand and agree that proxylink may, based on its sole discretion, notify you through web announcements, emails, mobile phone text messages or regular mail delivery, and you ensure that the contact information you provide is complete, accurate and currently valid. , the above notice shall be deemed to have been delivered to the recipient on the date of sending. If a change occurs, the changed information needs to be provided to proxylink in a timely manner through various methods provided by proxylink. Proxylink will be deemed to have delivered the notice after it sends a notification to the contact information you provided, regardless of whether the contact information is actually continued to be used by you. .',
        title116: '12.2 You shall deliver the notice you send to proxylink through the mailing address, fax number, email address, QQ, WeChat and other instant messaging methods or other contact information officially announced by proxylink.',
        title117: 'Article 13 Effectiveness and modification of the agreement',
        title118: '13.1 Your use of this service is deemed to have read this agreement and the "proxylink Privacy Agreement" and accepted the constraints of this agreement and the "proxylink privacy agreement".',
        title119: '13.2 Proxylink reserves the right to modify the terms of this Agreement. After modification, it will be published on the official website or notify you through the contact information you have reserved. You can check the latest version of the agreement terms on the relevant service page.',
        title120: 'Article 14 Law Application and Jurisdiction',
        title121: "14.1 The signing place of this agreement is Quanshan District, Xuzhou City, Jiangsu Province, the People's Republic of China.",
        title122: "14.2 The validity, interpretation, change, execution and dispute resolution of these Terms of Service shall be governed by the laws of the People's Republic of China (excluding conflict of laws).",
        title123: "14.3 Any disputes arising from these Terms of Service shall first be resolved through negotiation between the two parties; if the two parties fail to resolve the dispute through negotiation, either party may file a lawsuit with the People's Court of Quanshan District, Xuzhou City, Jiangsu Province, where this contract is signed.",
        title124: '14.4 The titles of all clauses in this Agreement are only for the convenience of reading and have no actual meaning in themselves and cannot be used as a basis for the interpretation of the meaning of this Agreement.',
        title125: '14.5 No matter whether part of the terms of this agreement is invalid or unenforceable for any reason, the remaining terms will still be valid and binding on both parties.',
        title126: 'Article 15 Others',
        title127: 'If you have any comments or suggestions about this Agreement or this service, you can contact us at any time and we will provide you with the necessary help. Corporate email: super@proxylink.net'
      },
      serviceDataZh: {
        title1: 'proxylink用户服务协议',
        title2: '协议最新更新时间：2023年07月15日',
        title3: '协议生效日期： 2023年07月15日',
        title4: 'proxylink用户服务协议是用户（“您”）与江苏艾迪信息科技有限公司（以下简称为"艾迪"或“我们”）之间就proxylink的官方网站（www.proxylink.net， “本网站”）服务等相关事宜所签订的合同， 请您仔细阅读，若您通过勾选、点击确认或以其他方式表示接受本协议，或您以任何方式使用proxylink服务的，即视为您已充分阅读、理解并同意接受本协议的约束，同时本协议即在您与proxylink之间产生法律效力。',
        title5: '第一条 总则',
        title6: '1.1 您在使用本服务之前，已经充分阅读、理解并接受本服务条款的全部内容（尤其是突出显示的内容），一旦您选择“同意”并完成账号注册或使用本服务，即表示您同意遵循本服务条款之所有约定。您使用proxylink服务的行为将被视为对本协议及《proxylink隐私协议》全部内容的认可。',
        title7: '1.2 您同意：proxylink保留随时更新本协议即相应服务规则内容的权利。如果proxylink更新了本附录，proxylink将通过发布官网公告的形式通知您。如您不同意更改，则您有权在新的协议或服务规则生效日期之前终止使用本服务。若您在新的协议或服务规则生效日期之后继续使用本服务视为接受新的协议或服务规则并放弃根据本条终止服务的权利。',
        title8: '1.3 在您完成账号注册或以其他proxylink允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力法律主体。若您不具备前述与您行为相适应的民事行为能力，则应获得法定监护人的知情同意。如您尚未成年，请在法定监护人的陪同下阅读和判断是否同意本协议。未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。',
        title9: '第二条 协议的范围',
        title10: '2.1 本协议是用户与proxylink之间关于使用proxylink的服务所订立的协议。“proxylink”是指proxylink和/或其相关服务可能存在的运营关联单位。“用户”是指proxylink的服务的使用人/使用企业（包括但不限于注册用户、免费用户，第三方渠道登录用户及合作伙伴、代理商所属用户），在本协议中更多地称为“您”。',
        title11: '2.2 proxylink的服务是指proxylink向您提供的，具体服务以proxylink实际提供的为准（以下简称“本服务”）。',
        title12: '2.3 本协议内容同时包括《proxylink隐私协议》，且您在使用proxylink某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您《proxylink隐私协议》的接受。',
        title13: '2.4 proxylink仅对本服务条款中列明的责任承担范围负责。',
        title14: '2.5 proxylink对于因本服务条款有关或由本服务条款引起的违约、侵权等导致的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不论是如何产生的，均不承担任何责任，即使事先已被告知可能发生此等损失。',
        title15: '第三条 账号与密码安全',
        title16: '3.1 为使用proxylink服务，您需要注册proxylink账号（以下简称“账号”）。在您按照注册页面提示填写信息、阅读并同意本服务条款且完成注册后，或您以其他proxylink允许的方式实际使用本网站服务时，您即受本服务条款约束。',
        title17: '3.2 您应依法具备必要、适当的权利能力和行为能力，已授予操作人足够的权利完成注册过程。您承诺提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新注册资料。您应对注册获得的proxylink账号项下的一切行为承担全部责任，不得侵犯包括但不限于proxylink在内的任何主体的合法权益。',
        title18: '3.3 您了解并同意：为保证账户和交易安全，proxylink有权随时要求您完成proxylink账户的实名认证；您的账户只有在通过这些认证和验证之后，才能获得使用proxylink相关服务的资格。',
        title19: '3.4 您同意或接受：在必要地情况下，我们有权使用您的注册信息、用户名、密码等信息，登录进入您的注册账户，进行证据保全，包括但不限于公证、见证等。',
        title20: '3.5 proxylink账号仅限于您自身使用，未经proxylink同意，您不得将账号以任何方式提供给他人使用。您应为账号下的行为负责，账号下的所有操作行为均被视为您实施，且应由您承担全部法律后果。',
        title21: '3.6 proxylink特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受被盗号或密码失窃，责任由您自行承担。',
        title22: '第四条 隐私及其他用户个人信息的保护',
        title23: '4.1 保护用户个人信息是proxylink的一项基本原则。proxylink将按照本协议及《proxylink隐私协议》的规定收集、使用、储存您的个人信息。本协议对个人信息保护相关内容未作明确规定的，均应以《proxylink隐私协议》的内容为准。',
        title24: '4.2 您在注册帐号或使用本服务的过程中，需要填写一些必要的信息（手机号或身份信息）。根据国家法律法规规定，您需要填写真实的身份信息。若您填写的信息不完整，则可能无法使用本服务或在使用过程中受到限制。',
        title25: '4.3 一般情况下，您可根据相关产品规则浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，您无法修改实名认证信息。',
        title26: '4.4 proxylink承诺会根据《proxylink隐私协议》对您资料采取对外保密措施，不向第三方披露您资料，不授权第三方使用您资料，除非：',
        title27: '（1）依据本用户协议或者您与proxylink之间其他文件规定可以提供；',
        title28: '（2）依据法律法规的规定应当提供；',
        title29: '（3）行政、司法以及其他国家有关部门要求proxylink提供；',
        title30: '（4）您同意proxylink向第三方提供；',
        title31: '（5）proxylink解决举报事件、提起诉讼而提交的；',
        title32: '（6）proxylink为防止违法违规、犯罪行为的发生而采取必要合理措施所必须提交的；',
        title33: '（7）proxylink为向您提供产品、服务、信息而向第三方提供的，包括proxylink通过第三方的技术及服务向您提供产品、服务、信息的情况。',
        title34: '4.5 proxylink仅按已有技术提供相应的安全措施来使proxylink管理的信息不丢失，但proxylink不承诺保证这些信息的绝对安全。',
        title35: '4.6 您同意：为了更好地为您提供服务，我们可能会在您提供信息地基础上，不定期地通过邮件、短信、电话等形式，向您发送订单信息、促销活动等，同时保障您被告知信息的权利。',
        title36: '第五条 服务',
        title37: '5.1 使用本服务的方式',
        title38: '5.1.1 您依本协议条款所取得的权利仅您本人享有，不可转让。',
        title39: '5.1.2 您不得使用任何方式（包括但不限于第三方软件、插件、系统、设备等）对本服务进行干扰、破坏、修改或施加其他影响。',
        title40: '5.1.3 您应当通过proxylink提供或认可的方式使用本服务。',
        title41: '5.1.4 您应当理解，您使用本服务需自行准备与相关服务有关的终端设备（如电脑、移动终端和必要的网络接入设备等装置），并承担所需的费用（如电话费、上网费等费用）。',
        title42: '5.1.5 您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。',
        title43: '5.2 服务费用',
        title44: '5.2.1 proxylink可能根据实际需要对收费服务的收费标准、方式进行修改和变更，proxylink也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，proxylink将在官网进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。',
        title45: '5.2.2 在proxylink降低收费服务的收费标准或者将收费服务改为免费服务提供时，proxylink保留不对原付费用户提供退费或者费用调整之权利。',
        title46: '5.2.3 您知晓并同意，发生如下情形之一的，proxylink将对您名下账户资金进行部分或全部冻结：',
        title47: '（1）国家法律、政策法规、生效法律文书的规定；',
        title48: '（2）有关国家主管部门要求进行冻结的；',
        title49: '（3）您使用proxylink服务的行为涉嫌违反国家法律法规的；',
        title50: '（4）您遭到他人投诉，且对方已经提供了初步证据，以至于proxylink有理由相信该投诉事项存在的；',
        title51: '（5）proxylink根据自行合理判断，认为可能产生风险的其他情况。',
        title52: '5.3 按现状提供服务',
        title53: '您理解并同意：',
        title54: '（1）本服务是按照现有技术和条件所能达到的现状提供的。proxylink会尽最大努力保障服务的连贯性和安全性，但proxylink不能随时预见和防范法律、技术以及其他风险，proxylink对此类风险在法律允许的范围内免责，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。',
        title55: '（2）proxylink可能根据经营策略或其他发展需求做产品或服务调整，不同地区的用户可使用的具体proxylink服务的内容可能会存在差异，具体以proxylink实际提供的为准。',
        title56: '（3）proxylink服务价格、数量、是否有货等信息随时都有可能发生变动，我们将不会对此作特别通知。我们会尽最大努力保证您在proxylink官方网页所浏览信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，proxylink官方网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解，并在使用proxylink服务时以实际情况为准。',
        title57: '（4）除非另有明确的书面说明,我们提供给您的全部信息、内容、材料、产品或服务，均是在"按现状"和"按现有"的基础上提供的。除非另有明确的书面说明，我们不对本网站的运营及其包含在本网站上的信息、内容、材料、产品或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。',
        title58: '（5）我们不担保本网站所包含的或以其它方式通过本网站提供给您的全部信息、内容、材料、产品和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，我们会合理地尽力协助处理善后事宜。',
        title59: '5.4 服务中止、变更、终止',
        title60: '5.4.1 您理解并同意，为了向您提供更加完善的服务，proxylink可能会进行例行、有计划的维护，可能导致您所使用服务短时间的中断或暂停，且基于经营策略的调整，可能会对服务内容进行变更，同样可能会导致服务中断或终止，对于此类维护导致的服务中断或暂停，proxylink无需向您承担任何责任。',
        title61: '5.4.2 proxylink有权按本协议约定进行收费。若您未按时足额付费，proxylink有权中断、中止或终止提供服务。',
        title62: '5.4.3 您有责任自行备份存储在本服务中的数据。如果您的服务被终止，proxylink有权从服务器上永久地封存您的数据，法律法规另有规定的除外。服务中止或终止后，proxylink没有义务向您提供或返还数据。',
        title63: '5.4.4 在proxylink发生合并、分立、收购、资产转让时，proxylink可向第三方转让本服务下相关资产；proxylink也可在单方通知您后，将本协议下部分或全部服务及相应的权利义务转交由第三方运营或履行。具体受让主体以proxylink的通知为准。',
        title64: '5.4.5 如发生下列任何一种情形，proxylink有权不经通知而中断或终止向您提供服务：',
        title65: '（1）根据法律法规规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；',
        title66: '（2）您违反相关法律法规的规定或违反本协议的约定；',
        title67: '（3）按照法律法规规定，因执行法院、政府机构、司法机关等有权机关指令所需；',
        title68: '（4）为处理proxylink服务安全性或完整性之紧急事件或其他必要的情形。',
        title69: '第六条 第三方提供的产品或服务',
        title70: '若您通过proxylink网站获取、使用第三方提供的产品或服务，此时第三方产品和服务的运营方与您建立相应的服务关系，并向您承担产品和服务的责任。proxylink根据服务规则约定仅在自身责任范围内向您承担相应责任。',
        title71: '第七条 用户违法违规行为',
        title72: '7.1 您在使用本服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：',
        title73: '（1）反对宪法所确定的基本原则的；',
        title74: '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
        title75: '（3）损害国家荣誉和利益的；',
        title76: '（4）煽动民族仇恨、民族歧视，破坏民族团结的；',
        title77: '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；',
        title78: '（6）散布谣言，扰乱社会秩序，破坏社会稳定的；',
        title79: '（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
        title80: '（8）侮辱或者诽谤他人，侵害他人合法权益的；',
        title81: '（9）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；',
        title82: '（10）相关法律法规或本协议、相关协议、规则等禁止的。',
        title83: '7.2 如果您在使用本服务过程中违反了相关法律法规或本协议约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求proxylink给予协助。因此给您或者他人造成损害的，您应自行承担全部责任，proxylink不承担任何责任。',
        title84: '7.3 如果您违反本协议约定，proxylink有权进行独立判断并采取相应措施。同时，proxylink有权视您的行为性质，采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对帐号使用，追究法律责任等措施。',
        title85: '7.4 您违反本协议约定，导致任何主体损失的，您应当独立承担责任；proxylink因此遭受损失的，您也应当一并赔偿。',
        title86: '7.5 您须对自己在网上的言论和行为承担法律责任，您若在本网站上散布和传播反动、色情或其它违反国家法律的信息，本网站的系统记录有可能作为您违反法律的证据。',
        title87: '第八条 知识产权',
        title88: '8.1 proxylink在本服务中提供的内容（包括但不限于网页、文字、图片等）的知识产权归proxylink所有，您在使用本服务中所产生内容的知识产权归您或相关权利人所有，除非您与proxylink另有约定。',
        title89: '8.2 除另有特别声明外，proxylink提供本服务时所依托的著作权、专利权及其他知识产权均归proxylink所有。',
        title90: '8.3 proxylink在本服务中所使用的“proxylink”、logo等商业标识，其著作权或商标权归proxylink所有。',
        title91: '8.4 上述及其他任何本服务包含的内容的知识产权均受到法律法规保护，未经proxylink、您或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。',
        title92: '8.5 尊重知识产权是您应尽的义务，如有违反，您应承担损害赔偿责任。',
        title93: '第九条 不可抗力及免责',
        title94: '9.1 不可抗力指协议各方所不能预见、或为各方所不能克服、不能避免的客观情况，包括但不限于：',
        title95: '9.1.1 自然灾害：如洪水、冰雹、海啸、台风、旱灾、火灾等；',
        title96: '9.1.2 政府行为：如政府当局颁布或调整、变更的政策、法律、法规和采取新的行为措施等导致协议不能履行；',
        title97: '9.1.3 社会异常现象：如骚乱、疾病、战争、罢工（但不包括各方内部劳资纠纷）等；其他不能预见、不能克服并不能避免且对一方或各方造成重大影响的事件。',
        title98: '出现上述情况时，proxylink将及时与有关部门配合，争取尽快进行处理，但是由此给您造成的损失，proxylink在法律允许的范围内免责。',
        title99: '9.2 因不可抗力导致任何一方（“受影响方”）无法履行本协议下的全部或部分义务，不视为受影响方违约，受影响方不承担因不可抗力导致的未履行或迟延履行本协议义务导致相对方遭受的任何损害、损失、或增加之费用。',
        title100: '9.3 您理解并同意，鉴于互联网产品服务的特性， 在法律允许的范围内，proxylink对以下情形导致的服务异常不承担责任：',
        title101: '（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏、电信部门技术调整或故障等原因而造成的服务中断或者延迟；',
        title102: '（2）您管理维护的软件、硬件设备、系统、通信线路出现故障，导致proxylink服务不能正常使用和造成其他衍生损害；',
        title103: '（3）您操作不当、错误操作或您通过非proxylink授权的方式使用本服务；',
        title104: '（4）程序版本过时、设备的老化和/或其兼容性问题；',
        title105: '（5）其他非proxylink过错所导致的、proxylink无法控制或合理预见的情形。',
        title106: '第十条 遵守当地法律监管',
        title107: '10.1 您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。',
        title108: '10.2 您应避免因使用本服务而使proxylink违反法律法规或卷入政治和公共事件，否则proxylink有权暂停或终止对您的服务。',
        title109: '第十一条 您发送、传播的内容与投诉处理',
        title110: '11.1 您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。',
        title111: '11.2 如果您发送或传播的内容违法违规或侵犯他人权利的，proxylink有权进行独立判断并采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对帐号使用。',
        title112: '11.3 如您被他人投诉或您投诉他人，proxylink有权将争议中相关方的主体信息、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。',
        title113: '11.4 您保证对您在投诉处理程序中提供的信息、材料、证据等的真实性、合法性、有效性负责。',
        title114: '第十二条 通知送达',
        title115: '12.1 您理解并同意，proxylink可依据自行判断，通过网页公告、电子邮件、手机短信或常规的信件传送等方式向您发出通知，且您确保您所提供的联系信息是完整、准确且当前有效的，上述通知于发送之日视为已送达收件人。如发生变更，需以各种proxylink提供的方式及时向proxylink提供变更后的信息，proxylink向您提供的联系信息发送通知后即视为送达，而无论该联系信息事实上是否由您本人继续使用。',
        title116: '12.2 您应当通过proxylink对外正式公布的通信邮寄地址、传真号码、电子邮件地址、QQ、微信等即时通讯方式或其他联系信息进行送达您给proxylink发送的通知。',
        title117: '第十三条 协议的生效与变更',
        title118: '13.1 您使用本服务即视为您已阅读本协议、《proxylink隐私协议》,并接受本协议、《proxylink隐私协议》的约束。',
        title119: '13.2 proxylink保留对本协议条款的修改权，修改后将会在官网发布或通过您预留的联系方式向您发送通知。您可以在相关服务页面查阅最新版本的协议条款。',
        title120: '第十四条 法律适用与管辖',
        title121: '14.1 本协议的签订地为中华人民共和国江苏省徐州市泉山区。',
        title122: '14.2 本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律（不包括冲突法）。',
        title123: '14.3 因本服务条款产生之争议，双方应首先协商解决；双方未能协商解决的，任何一方均可向本合同签订地江苏省徐州市泉山区人民法院提起诉讼。',
        title124: '14.4 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。',
        title125: '14.5 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。',
        title126: '第十五条 其他',
        title127: '如果您对本协议或本服务有意见或建议，可以随时与我们联系，我们会给予您必要的帮助。企业邮箱：super@proxylink.net',
      }
    }
  },
  computed: {
    t() {
      const lang = this.languageState.currentLanguage;
      return {
        home: lang === 'zh' ? '首页' : 'Home',
        services: lang === 'zh' ? '套餐' : 'Package',
        serviceDynamic: lang === 'zh' ? '动态住宅' : 'Dynamic residence',
        serviceStatic: lang === 'zh' ? '静态住宅' : 'Static residence',
        blog: lang === 'zh' ? '教程中心' : 'Tutorial Center',
        faq: lang === 'zh' ? '常见问题' : 'FAQ',
        signIn: lang === 'zh' ? '登录' : 'Sign In',
        signUp: lang === 'zh' ? '注册' : 'Sign Up',
        servicePolicyTitle: lang === 'zh' ? '服务政策' : 'Service Policy',
        servicePolicySubtitle: lang === 'zh' ? '了解我们的服务条款和条件' : 'Learn about our service terms and conditions',
        // Footer translations
        contactInfo: lang === 'zh' ? '联系我们' : 'Contact Info',
        usefulLinks: lang === 'zh' ? '有用链接' : 'Useful Links',
        support: lang === 'zh' ? '支持' : 'Support',
        privacyPolicy: lang === 'zh' ? '隐私政策' : 'Privacy Policy',
        servicePolicy: lang === 'zh' ? '服务政策' : 'Service Policy',
        welcomeText: lang === 'zh' ? '欢迎尝试我们的产品！' : 'Welcome to try our products!',
        copyright: lang === 'zh' ? 'ProxyLink. © 2023 保留所有权利。' : 'ProxyLink. © 2023 All Rights Reserved.'
      };
    }
  },
  methods: {
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = null;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    handleScroll() {
      const scrollPosition = window.pageYOffset;
      this.showGoTop = scrollPosition > 300;
      this.isSticky = scrollPosition > 100;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.scrollToTop();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}
/* Banner Section */
.faq-banner-section {
  background-color: #F7FAFD;
  text-align: center;
}

.faq-banner-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
  position: relative;
  display: inline-block;
}

.faq-banner-section h1::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: linear-gradient(135deg, #4146E6 0%, #6a30d1 100%);
  border-radius: 2px;
  transform: translateY(5px);
}

.faq-banner-section p {
  font-size: 1.125rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* Policy Content Section */
.policy-content-section {
  background: #f8f9fa;
}

.policy-content {
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.policy-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #f0f2f5;
}

.policy-header h2 {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #2c3e50;
}

.policy-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 0.9rem;
  color: #666;
}

.policy-body {
  line-height: 1.8;
  color: #444;
}

.policy-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f2f5;
}

.policy-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.policy-section h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
  padding-left: 10px;
  border-left: 4px solid #007bff;
}

.policy-section h4 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 20px 0 10px;
  color: #333;
}

.policy-section p {
  margin-bottom: 15px;
  text-align: justify;
}

/* Responsive Design */
@media (max-width: 768px) {
  .policy-content {
    padding: 25px;
  }
  
  .policy-header h2 {
    font-size: 1.8rem;
  }
  
  .policy-meta {
    flex-direction: column;
    gap: 10px;
  }
  
  .policy-section h3 {
    font-size: 1.3rem;
  }
  
  .policy-section h4 {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .policy-content {
    padding: 20px 15px;
  }
  
  .policy-header h2 {
    font-size: 1.5rem;
  }
  
  .policy-section h3 {
    font-size: 1.2rem;
  }
}

/* Go Top Button */
.go-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  background: #007bff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.go-top.active {
  opacity: 1;
  visibility: visible;
}

.go-top:hover {
  background: #0056b3;
  transform: translateY(-3px);
}

.footer-section {
  background-color: var(--blackColor);
  /* padding-bottom: 70px; */
}

.footer-widget {
  margin-bottom: 30px;
  padding: 10px 0;
}

.footer-widget .logo {
  margin-bottom: 15px;
  display: block;
}

.footer-widget .logo .logo-text {
  -webkit-text-fill-color: transparent;
  align-items: center;
  background: -webkit-gradient(linear, left top, left bottom, from(#428bf3), to(#3e30ff));
  -webkit-background-clip: text;
  background-clip: text;
  display: flex;
  flex-shrink: 0;
  font-size: 25px;
  font-weight: 700;
  height: 1.9rem;
  justify-content: space-between;
  /* margin-right: 35px; */
  text-align: center;
  cursor: pointer;
}

.footer-widget h3 {
  font-size: 20px;
  margin-bottom: 20px;
  color: var(--whiteColor);
}

.footer-widget p {
  opacity: 0.8;
  color: var(--whiteColor);
  margin-bottom: 15px;
  line-height: 1.6;
}

.footer-widget .links-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.footer-widget .links-list li {
  margin-bottom: 12px;
}

.footer-widget .links-list li:last-child {
  margin-bottom: 0;
}

.footer-widget .links-list li a {
  position: relative;
  display: inline-block;
  color: var(--whiteColor);
  opacity: 0.8;
  /* padding: 5px 0; */
  padding: 4px;
  display: block;
}

.footer-widget .links-list li a:hover {
  opacity: 1;
  color: var(--mainColor);
}

.footer-widget .footer-contact-info {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.footer-widget .footer-contact-info li {
  opacity: 0.8;
  position: relative;
  margin-bottom: 15px;
  color: var(--whiteColor);
  padding-left: 0;
  line-height: 1.6;
}

.footer-widget .footer-contact-info li:last-child {
  margin-bottom: 0;
}

.footer-widget .footer-contact-info li a {
  color: var(--whiteColor);
  text-decoration: none;
}

.footer-widget .footer-contact-info li a:hover {
  color: var(--mainColor);
}

.footer-widget .footer-contact-info li::before {
  display: none;
}

.footer-widget .social-links {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 25px;
}

.footer-widget .social-links li {
  display: inline-block;
  margin-right: 10px;
}

.footer-widget .social-links li a {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border-radius: 50%;
  text-align: center;
  color: var(--blackColor);
  background-color: var(--whiteColor);
  transition: all 0.3s ease;
}

.footer-widget .social-links li a i {
  line-height: 1;
}

.footer-widget .social-links li a:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
  transform: translateY(-3px);
}

.footer-widget .social-links li:last-child {
  margin-right: 0;
}

.copyright-area {
  background-color: #3B566E;
  padding: 20px 0;
  margin-top: 40px;
}

.copyright-area p {
  color: var(--whiteColor);
}

.copyright-area p strong {
  color: var(--whiteColor);
}

.copyright-area p a {
  font-weight: 700;
  color: var(--whiteColor);
}

/* Mobile Menu Button Styles */
@media (max-width: 991px) {
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
}
</style>